import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { routes } from "@root/common/routes";
import { HttpClient } from "@angular/common/http";
import format from "date-fns/format";
import { NzModalRef, NzModalService } from "ng-zorro-antd/modal";
import _, { range } from "lodash";
import { TranslateService } from "@root/shared/service/translate.service";
import * as moment from "moment";
import { AppService } from "@root/app.service";
import { Router } from "@angular/router";
import { CacheService } from "@delon/cache";
import { splitCountryCodeAndMobile } from "@root/util/util";
import { NzSelectComponent } from "ng-zorro-antd/select";

@Component({
  selector: "host-edit-guest",
  templateUrl: "./edit-guest.component.html",
  styleUrls: ["./edit-guest.component.scss"],
})
export class EditGuestComponent implements OnInit {
  private readonly editClientApi = "/api/client/client_save";
  private readonly countryListApi = "/api/client/areas";
  private readonly tagListApi = "/api/house_status_setting/get";
  @Input() type: "create" | "update" = "create";
  @Input() guestInfo = null; // type = 'create' 时传递过来的填充数据
  // @Output() onSuccess = new EventEmitter();
  _idTypeOptions = [
    { label: "身份证", value: "id_card", key: "guest.list.id_card" },
    { label: "护照", value: "passport", key: "guest.list.passport" },
    { label: "港澳台通行证", value: "gang_ao_tai_card", key: "guest.list.exit_entry_permit" },
    { label: "军人证", value: "serviceman_card", key: "guest.list.military_id" },
  ];

  monthOptions = range(0, 12).map((i) => ({
    label: this.t.t("word.month_" + i),
    value: i,
  }));
  dateOptions = range(1, 32).map((i) => ({ label: i, value: i }));

  countryOptions = [];
  tagOptions = [];

  listOfCountryCode = [];
  countryCode;

  form: UntypedFormGroup = this.fb.group({
    id: null,
    name: "",
    gender: 1,
    phone: "",
    email: "",
    id_type: [null],
    id_number: "",
    // @deprecated
    // birthday: [null],
    year: moment().subtract(30, "year").toDate(),
    month: 0,
    date: 1,

    country: "",
    comment: "",
    client_tags: [[]],
    client_credential: [[]],
  });

  get isInternational() {
    return this.app.app.international;
    // return this.international.isInternational();
  }

  get idTypeOptions() {
    return this.isInternational ? this._idTypeOptions.slice(0, 2) : this._idTypeOptions;
  }
  constructor(
    private http: HttpClient,
    private router: Router,
    private fb: UntypedFormBuilder,
    private modalRef: NzModalRef,
    private modalService: NzModalService,
    private t: TranslateService,
    private cache: CacheService,
    // private international: InternationalService,
    private app: AppService,
  ) {}

  ngOnInit() {
    this.requestCountryList();
    this.requestTagList();
    if (this.guestInfo) {
      const [countryCode, phone] = splitCountryCodeAndMobile(this.guestInfo.phone);
      this.countryCode = countryCode;

      this.form.patchValue({ ...this.guestInfo, phone });
      if (this.guestInfo.birthday) {
        const m = moment(this.guestInfo.birthday);
        this.form.patchValue({
          year: m.toDate(),
          month: m.month(),
          date: m.date(),
          // birthday: moment(this.guestInfo.birthday).toDate(),
        });
        console.log("m: ", m, " form: ", this.form.value);
      }
      this.form.patchValue({
        client_tags: (this.guestInfo.client_tags || []).map((t) => t.id),
      });
    }

    if (this.isInternational) {
      this.fetchCountryCodes();
    }
  }

  private fetchCountryCodes() {
    this.cache.get("/api/schedule/staff/mobile_codes").subscribe((rst: any) => {
      this.listOfCountryCode = rst?.data?.codes?.map((c) => ({
        label: c,
        value: c,
      }));
      if (!this.countryCode) {
        this.countryCode = this.listOfCountryCode?.[0]?.value;
      }
    });
  }

  requestCountryList() {
    const params = { format: "all" };
    this.http.get(this.countryListApi, { params }).subscribe((res) => {
      const areas = _.get(res, "data") || [];
      this.countryOptions = _.flatten(_.map(areas, "members")).map((item) => ({
        label: item.name,
        value: item.alpha2,
      }));
    });
  }

  requestEditGuest() {
    const value = this.form.value;

    const phone = value.phone ? (this.isInternational ? `${this.countryCode} ${value.phone}` : value.phone) : null;

    const { year, month, date } = value;
    console.log("year: ", year);
    const birthday = moment(year)
      .set({
        month,
        date,
      })
      .format("YYYY-MM-DD");

    const params = { ...value, phone };

    const tagIds = value.client_tags;
    params.client_credential = JSON.stringify(value.client_credential);
    params.birthday = birthday;
    params.tag_ids = JSON.stringify(tagIds);

    delete params["client_tags"];

    this.http.post(this.editClientApi, params).subscribe((res: any) => {
      if (res.error_code === 0) {
        const id = _.get(res, "data.id");
        const hasSimilar = _.get(res, "data.has_similar");
        if (hasSimilar /* @TODO 接口缺少字段 */) {
          this.modalService.warning({
            nzTitle: this.t.syncGet("modal.add_guest.warning_title"),
            nzOkText: this.t.syncGet("modal.add_guest.warning_btn"),
          });
        }

        this.modalRef.destroy({
          type: "onSuccess",
          data: { id },
        });
      }
    });
  }

  requestTagList() {
    this.http.get(this.tagListApi).subscribe((res: any) => {
      const list = (res?.data?.client_tag_list || []).filter((item) => !item.delete_time);

      this.tagOptions = list.map((item) => ({
        label: item.name,
        value: item.id,
      }));
    });
  }

  toSettingOptionPage() {
    this.router.navigate([routes.SettingConfig], { queryParams: { anchor: "tags" } });
    this.modalRef.destroy();
  }

  onClickConfirm() {
    this.requestEditGuest();
  }

  onClickCancel() {
    this.modalRef.destroy();
  }

  /** trick  */
  onSearchBlur(tpl: NzSelectComponent) {
    this.countryCode = tpl.activatedValue;
  }
}
